(() => {
  const initAcademy = () => {
    const academy = document.querySelector('[data-m8-academy]');
    if (!academy) return;

    const storageKey = academy.dataset.progressKey;
    const player = academy.querySelector('[data-course-player]');
    const nowPlaying = academy.querySelector('[data-now-playing]');
    const progressCount = academy.querySelector('[data-progress-count]');
    const progressBar = academy.querySelector('[data-progress-bar]');
    const lessons = Array.from(academy.querySelectorAll('[data-lesson]'));
    let completeIds = new Set();

    try {
      const saved = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(saved)) completeIds = new Set(saved);
    } catch (_) {
      completeIds = new Set();
    }

    const saveProgress = () => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify([...completeIds]));
      } catch (_) {
        // The course remains usable if browser storage is unavailable.
      }
    };

    const renderProgress = () => {
      const total = lessons.length;
      const completed = completeIds.size;
      if (progressCount) progressCount.textContent = completed;
      if (progressBar) progressBar.style.width = `${total ? (completed / total) * 100 : 0}%`;
      lessons.forEach((lesson) => {
        const isComplete = completeIds.has(lesson.dataset.lessonId);
        const control = lesson.querySelector('[data-mark-complete]');
        if (!control) return;
        control.classList.toggle('is-complete', isComplete);
        control.setAttribute('aria-pressed', String(isComplete));
        control.textContent = isComplete ? 'Completed' : 'Mark complete';
      });
    };

    const playLesson = (lesson) => {
      if (!lesson || !player) return;
      player.src = lesson.dataset.embedUrl;
      player.title = `${lesson.dataset.lessonNumber}: ${lesson.dataset.lessonTitle}`;
      if (nowPlaying) {
        nowPlaying.querySelector('strong').textContent = `${lesson.dataset.lessonNumber} - ${lesson.dataset.lessonTitle}`;
        nowPlaying.querySelector('small').textContent = lesson.dataset.lessonDuration;
      }
      player.closest('.m8-academy__player-wrap').scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    lessons.forEach((lesson) => {
      lesson.querySelectorAll('[data-play-lesson]').forEach((control) => control.addEventListener('click', () => playLesson(lesson)));
      lesson.querySelector('[data-mark-complete]')?.addEventListener('click', () => {
        const id = lesson.dataset.lessonId;
        if (completeIds.has(id)) completeIds.delete(id); else completeIds.add(id);
        saveProgress();
        renderProgress();
      });
    });

    academy.querySelectorAll('[data-tab-target]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tabTarget;
        academy.querySelectorAll('[data-tab-target]').forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        academy.querySelectorAll('[data-panel]').forEach((panel) => {
          const active = panel.dataset.panel === target;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });

    renderProgress();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAcademy);
  else initAcademy();
})();
